module.exports = __webpack_public_path__ + "assets/img/social/discord-icon.120f11bb79421a010e3da9b26f461e97.svg";